import { FormValidator, ValidationRules } from 'src/utils/FormValidator';

export const BusinessUnitValidationPaths = {
  NAME: {
    path: 'name',
    message: 'Error: Please enter the business unit.',
  },
  NAME_WHITESPACE: {
    path: 'name',
    message: 'Error: Business unit name cannot have leading or trailing spaces.',
  },
  DESCRIPTION: {
    path: 'description',
    message: 'Error: Please enter the description.',
  },
} as const;

export const BusinessUnitValidator = (): FormValidator => {
  const validator = new FormValidator();

  validator.addRule(
    BusinessUnitValidationPaths.NAME.path,
    ValidationRules.required,
    BusinessUnitValidationPaths.NAME.message,
  );

  validator.addRule(
    BusinessUnitValidationPaths.NAME_WHITESPACE.path,
    ValidationRules.custom((value: string) => !value || value === value.trim()),
    BusinessUnitValidationPaths.NAME_WHITESPACE.message,
  );

  validator.addRule(
    BusinessUnitValidationPaths.DESCRIPTION.path,
    ValidationRules.required,
    BusinessUnitValidationPaths.DESCRIPTION.message,
  );

  return validator;
};
